import { isObject } from './utils';
import { apiErrorLogs } from '@/omega/common/logs';

/**
 * 通用错误处理中间件 处理errno!==0 的情况, 返回result.data
 */
export function errnoDataMiddleware(request, response) {
  return new Promise((resolve, reject) => {
    response
      .then((result) => {
        if (Number(result.errno) !== 0) {
          const { params = [] } = request;
          const currentAPIPath = params[0] || '';
          // 接口请求异常埋点上报
          apiErrorLogs(result, currentAPIPath);

          reject(result);
        } else {
          // 将result.data同级数据挂载到result.data._meta上
          const data = result.data;
          if (isObject(data)) {
            data._meta = result;
            delete data._meta.data;
            resolve(data);
          } else {
            resolve(data);
          }
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
}
